import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class EmbedStylesService {
  addEmbedStyles(embedStyles: string) {}
}
